import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import './Register.css';

const modulesList = [
    { key: 'inicio', label: 'Inicio' },
    { key: 'reportes', label: 'Reportes' },
    { key: 'reservas', label: 'Reservas' },
    { key: 'pacientes', label: 'Pacientes' },
    { key: 'profesionales', label: 'Profesionales' },
    { key: 'productos', label: 'Productos' },
    { key: 'pedidos', label: 'Pedidos' },
    { key: 'inventarios', label: 'Inventarios' },
    { key: 'gastos', label: 'Gastos' },
    { key: 'evaluaciones', label: 'Evaluaciones' },
    { key: 'medios-pago', label: 'Medios de Pago' },
    { key: 'categorias', label: 'Categorías' },
    { key: 'banners', label: 'Banners' },
    { key: 'contacto', label: 'Contacto' },
    { key: 'usuarios', label: 'Usuarios' },
    { key: 'codigos', label: 'Códigos' },
    { key: 'testimonios', label: 'Testimonios' },
    { key: 'sucursales', label: 'Sucursales' },
    { key: 'horarios', label: 'Horarios' },
    { key: 'pwa', label: 'PWA' },
    { key: 'configuracion', label: 'Configuración' }
];

export default function Register() {
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [rol, setRol] = useState(''); // Estado para el rol
    const [contrasena, setContrasena] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [mensaje2, setMensaje2] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [formularioEnviado, setFormularioEnviado] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const [permisos, setPermisos] = useState(
        modulesList.reduce((acc, m) => {
            acc[m.key] = { ver: false, editar: false };
            return acc;
        }, {})
    );

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const crearCatalogo = async (e) => {
        e.preventDefault();
        setMensaje2('Procesando...');
        try {
            const formData = new FormData();
            formData.append('nombre', nombre);
            formData.append('email', email);
            formData.append('rol', rol);
            formData.append('contrasena', contrasena);
            formData.append('permisos', rol === 'empleado' ? JSON.stringify(permisos) : '');

            const response = await fetch(`${baseURL}/registroPost.php`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                if (data.mensaje) {
                    setMensaje(data.mensaje);
                    toast.success(data.mensaje);
                    setMensaje2('');
                    setFormularioEnviado(false);
                    window.location.reload();
                } else if (data.error) {
                    setError(data.error);
                    toast.error(data.error);
                    setMensaje2('');
                }
            } else {
                throw new Error('Error en la solicitud al servidor');
            }
        } catch (error) {
            console.error('Error:', error.message);
            toast.error(error.message);
            setMensaje2('');
        }
    };

    return (
        <div>
            
            <button onClick={toggleModal} className='btnSave'>
                <span>  +</span>   Agregar
            </button>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content" style={{ maxWidth: rol === 'empleado' ? '800px' : '500px', transition: 'max-width 0.3s ease' }}>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Usuario</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form onSubmit={crearCatalogo} id='crearForm'>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        type="text"
                                        id="nombre"
                                        name="nombre"
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                        required
                                        placeholder="Nombre"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Email</legend>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        placeholder="Email"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Rol</legend>
                                    <select
                                        id="rol"
                                        name="rol"
                                        value={rol}
                                        onChange={(e) => setRol(e.target.value)}
                                        required
                                    >
                                        <option value="">Seleccione un rol</option>
                                        <option value="admin">Administrador</option>
                                        <option value="empleado">Empleado</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Contraseña</legend>
                                    <div className='deFlexPass'>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            id="contrasena"
                                            name="contrasena"
                                            value={contrasena}
                                            onChange={(e) => setContrasena(e.target.value)}
                                            required
                                            placeholder="Contraseña"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                        </button>
                                    </div>
                                </fieldset>
                            </div>

                            {rol === 'empleado' && (
                                <div className="permisos-container">
                                    <h3 style={{ margin: '15px 0 10px', fontSize: '1.1rem', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Configurar Permisos de Empleado</h3>
                                    <div className="permisos-scroll" style={{ maxHeight: '250px', overflowY: 'auto', paddingRight: '5px' }}>
                                        <table className="permisos-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                                                    <th style={{ padding: '8px' }}>Módulo</th>
                                                    <th style={{ padding: '8px', textAlign: 'center' }}>Ver</th>
                                                    <th style={{ padding: '8px', textAlign: 'center' }}>Editar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {modulesList.map((m) => (
                                                    <tr key={m.key} style={{ borderBottom: '1px solid #eee' }}>
                                                        <td style={{ padding: '8px', fontWeight: '500' }}>{m.label}</td>
                                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                                                checked={permisos[m.key]?.ver || false}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setPermisos(prev => ({
                                                                        ...prev,
                                                                        [m.key]: {
                                                                            ...prev[m.key],
                                                                            ver: checked,
                                                                            editar: checked ? prev[m.key].editar : false
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </td>
                                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                                                checked={permisos[m.key]?.editar || false}
                                                                disabled={!permisos[m.key]?.ver}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setPermisos(prev => ({
                                                                        ...prev,
                                                                        [m.key]: {
                                                                            ...prev[m.key],
                                                                            editar: checked
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            {mensaje2 ? (
                                <button type="button" className='btnLoading' disabled style={{ marginTop: '15px' }}>
                                    {mensaje2}
                                </button>
                            ) : (
                                <button type="submit" className='btnPost' style={{ marginTop: '15px' }}>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
